import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AnalyticsService } from './core/services/analytics.service';
import { SeoService } from './core/services/api/seo.service';

@Component({
    selector: 'app-root',
    standalone: false,
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    title = 'umw-e-commerce-web';
    private lastPath = '';

    constructor(
        @Inject(PLATFORM_ID) private platformId: object,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private seoService: SeoService,
        private analyticsService: AnalyticsService,
    ) {}

    ngOnInit(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        this.analyticsService.initialize();

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            const skipScroll = this.router.getCurrentNavigation()?.extras?.state?.['skipScroll'];
            const currentPath = event.urlAfterRedirects.split('?')[0];
            const hasQueryParams = event.urlAfterRedirects.includes('?');

            if (!skipScroll && (currentPath !== this.lastPath || !hasQueryParams)) {
                window.scrollTo({ top: 0 });
            }

            this.lastPath = currentPath;

            this.updateSeo();
        });
    }

    private updateSeo(): void {
        const route = this.getDeepestChild(this.activatedRoute);
        const seo = route.snapshot.data['seo'];

        if (seo) {
            this.seoService.updateSeo({
                title: seo.title,
                description: seo.description,
            });
        } else {
            // Default SEO
            this.seoService.updateSeo({
                title: 'Forklift Rental Solutions for Warehouses & Logistics | Sime UMW Industries Rental Hub',
                description:
                    'Rent reliable forklifts for warehouses, logistics, and industrial operations. Flexible rental plans, fast delivery, and professional support.',
            });
        }
    }

    private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
        while (route.firstChild) {
            route = route.firstChild;
        }

        return route;
    }
}
